/* global $ */
import { core } from '@/core'

const dropDownUtil = {
  unit(opt, tar) {
    core.update(this.updater, opt, tar)
    $(tar.anchor).scroll(
      $.proxy(this.hasLocation, tar, tar.unit, tar.drop, tar.anchor)
    )
  },
  updater: {
    unit(value, opt, tar, node) {
      tar.unit = value
    },
    drop(value, opt, tar, node) {
      tar.drop = value
    },
    anchor(value, opt, tar, node) {
      tar.anchor = value
    },
    input(value, opt, tar, node) {
      tar.input = value
    },
  },
}

export default class DropDown {
  constructor(opt) {
    this.defaults = {
      anchor: 'window', // 滚动锚点
      unit: {}, // 主控件
      drop: {}, // 下拉菜单
      input: {}, // 输入框
      show: false, // 显示
    }
    this.item = [] // 储存组件局部信息
    core.proxyApi(this) // 核心属性处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init() {
    dropDownUtil.unit(this.settings, this)
  }

  update(fn) {
    this._update = fn
  }

  handleWinClick(fn) {
    if ($.type(fn) === 'function') $(window).click($.proxy(fn, this))
  }
}
